<template>
    <div>
        <div
            class="mt-input"
            :class="{ disabled, active, filled, invalid }"
            @click="$emit('click', $event)"
        >
            <div v-if="coins" class="coins">{{ coins }}</div>

            <div
                v-if="label"
                class="label"
                :class="{ 'hold-place': !filled, invalid }"
            >
                {{ label}}<span class="required" v-if="required">&nbsp;&nbsp;*</span>
            </div>

           
            <input 
                v-bind="$attrs"
                v-if="inputComponent === 'input'"
                class="mt-input__value"
                :type="type"
                :class="{ disabled, invalid }"
                :value="innerValue"
                @input="inputHandler"
                @change="changeHandler"
                ref="field"
                :disabled="disabled"
                :readonly="readonly"
                @focus="active = true"
                @blur="active = false"
                :maxlength="maxlength"
            />
            <font-awesome-icon 
                @click="showPassword = !showPassword" 
                class="icon" 
                :icon="showPassword ? 'eye' : 'eye-slash'"
            />
        </div>
        <div v-if="errorMessage" class="mt-invalid">
            <div class="mt-invalid-text">
                {{ errorMessage }}
            </div>
        </div>
    </div>
</template>

<script>
import Inputmask from 'inputmask';

export default {
    name: 'ModelPassword',
    inheritAttrs: false,
    props: {
        coins: Number,
        label: String,
        value: [String, Object, Array, Number],
        disabled: {
            type: Boolean,
            default: false,
        },
        disabledValue: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        valid: {
            type: Boolean,
            default: true,
        },
        mask: {
            type: String,
            default: null,
        },
        maskPlaceholder: {
            type: String,
            default: '_',
        },
        inputFilter: {
            type: Function,
            default: null,
        },
        invalidateFunction: {
            type: Function,
            default: null,
        },
        required: {
            type: Boolean,
            default: false,
        },
        maxlength: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            innerValue: this.value,
            active: false,
            showPassword: false,
        };
    },
    model: {
        prop: 'value',
        event: 'change',
    },
    watch: {
        value(str) {
            this.innerValue = str;
        },
        innerValue(str) {
            this.$emit('change', str);
        },
        mask() {
            this.applyMask();
        },
    },
    mounted() {
        this.applyMask();
    },
    computed: {
        type() {
            return this.showPassword ? 'text' : 'password';
        },

        inputComponent() {
            if (this.type === 'tel') return 'TelInput';

            return 'input';
        },

        filled() {
            return this.active || this.value;
        },

        invalid() {
            return (
                !this.valid ||
                (this.invalidateFunction && this.invalidateFunction(this.value))
            );
        },

        errorMessage() {
            return this.invalidateFunction
                ? this.invalidateFunction(this.value)
                : '';
        },
    },
    methods: {
        inputValueHandler(value) {
            this.innerValue = value;
        },
        inputHandler(evt) {
            let value = evt.target.value;
            const input = this.$refs.field;
            if (this.inputFilter) {
                if (this.inputFilter(value)) {
                    this.innerValue = value;
                } else {
                    input.value = this.innerValue || '';
                }
            } else {
                this.innerValue = value;
            }
        },
        changeHandler(evt) {
            const value = evt.target.value;
            if (this.maxlength) {
                if(value.length > Number(this.maxlength)){
                    this.innerValue = this.value.slice(0, Number(this.maxlength));
                }
            }
        },
        applyMask() {
            if (this.inputComponent !== 'input') return;
            Inputmask.remove(this.$refs.field);
            if (this.mask) {
                let m = new Inputmask(this.mask, {
                    placeholder: this.maskPlaceholder,
                });
                m.mask(this.$refs.field);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/mt';

.icon {
    color: #98A0A9;
}
</style>
